import { Component } from '@inter-ikea-core/core';

/**
 * Added to entities that should have the rotate option in the context menu when selected.
 */
export default class RotatableComponent implements Component {
  static id = 2088;
  typeId = RotatableComponent.id;
  doStoreInSnapshot: boolean = true;
  serializable: boolean = false;

  eq() {
    return true;
  }
}
